import { Schedule } from "../../../jobsite/components/WeeklyCalendar";
import {
  TValuationStatus,
  VALUATION_STATUS,
} from "../../../../api/valuation/valuation.types";
import {
  resetStateSuggestions,
  TContractPageFilters,
} from "./useContractPageUrlParams";

type TSuggestionsContract = {
  candidateSearchSchedule?: Schedule | null;
};

const scheduleHasRanges = (schedule?: Schedule | null): schedule is Schedule =>
  !!schedule &&
  typeof schedule === "object" &&
  Object.values(schedule).some(
    (ranges) => Array.isArray(ranges) && ranges.length > 0
  );

/**
 * Default filters when entering the "Añadir" (SEARCH) or OUTSTANDING tabs.
 * In "Añadir" the contract schedule is preloaded in the "Horario" filter
 * (ECO-1373) so only candidates who want it (preferences) and can work it
 * (no collision with their occupied slots) are proposed.
 */
export function getSuggestionsDefaultFilters(
  estadoEnProceso: TValuationStatus,
  contract?: TSuggestionsContract | null
): TContractPageFilters {
  const schedule = contract?.candidateSearchSchedule;
  const preferenceSchedule =
    estadoEnProceso === VALUATION_STATUS.SEARCH && scheduleHasRanges(schedule)
      ? JSON.stringify(schedule)
      : "";

  return {
    ...resetStateSuggestions,
    selectedValuationId: "",
    estadoEnProceso,
    page: 1,
    ready: true,
    preferenceSchedule,
  };
}
